import React, { Component } from 'react'
import PropTypes from 'prop-types'
import toCssClasses from './toCssClasses'
import grid from './grid.module.css'

class Row extends Component {
   makeFullClasses() {

      const { justifyContent, alignItems, spacing, className } = this.props

      let classes = []
      classes.push(grid.row)

      if(className)
      classes.push(className)

      if(justifyContent)
      classes = toCssClasses(justifyContent, 'justify-content', classes)

      if(alignItems)
      classes = toCssClasses(alignItems, 'align-items', classes)

      if(spacing)
      classes.push(grid[`col-spacing-${spacing}`])

      return classes.join(' ')
   }

   render() {
      return (
         <div className={this.makeFullClasses()} style={{ ...this.props.style }}>
            {this.props.children}
         </div>
      )
   }
}

Row.propTypes = {
   justifyContent: PropTypes.string,
   alignItems: PropTypes.string
}

export default Row


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Grid/Row.js